function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFF",
  strokeWidth: 3.795,
  d: "M47 30.2H30.201V47l-11.4-.002V30.197H2V18.8h16.801V2h11.398v16.8H47z"
});

var SvgPlusOutline = function SvgPlusOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/plus-outline.1f5de97d.svg";
export { SvgPlusOutline as ReactComponent };